import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["skip"];
import { useQuery } from '@apollo/client';
import { DEAL_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useQuerySelector } from 'utility-belt/hooks/useQuerySelector';
import { FETCH_CONVERSION_CANDIDATE } from '../fragments/ConvertFragments';
import { isDeal } from '../utils/types';
function isValidResponse(data) {
  if (!data) {
    return false;
  }
  return isDeal(data);
}
export function useFetchConversionCandidate(objectTypeId, objectId, _ref = {}) {
  let {
      skip: skipOption
    } = _ref,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  const skip = objectTypeId !== DEAL_TYPE_ID || !objectId || skipOption;
  return useQuery(FETCH_CONVERSION_CANDIDATE, Object.assign({
    skip,
    notifyOnNetworkStatusChange: true,
    variables: {
      objectId: objectId || -1,
      objectTypeId
    }
  }, options));
}
export function useConversionCandidate(objectTypeId, objectId, options = {}) {
  const query = useFetchConversionCandidate(objectTypeId, objectId, options);
  return useQuerySelector(query, data => {
    var _data$crmObject, _data$crmObject$defau, _data$crmObject2, _data$crmObject$defau2, _data$crmObject3, _data$crmObject4, _data$crmObject5;
    if (!isValidResponse(data === null || data === void 0 ? void 0 : data.crmObject)) {
      return {
        currencyCode: null,
        title: '',
        lineItems: [],
        contactId: null,
        companyId: null
      };
    }
    return {
      currencyCode: data === null || data === void 0 || (_data$crmObject = data.crmObject) === null || _data$crmObject === void 0 || (_data$crmObject = _data$crmObject.defaultProperties) === null || _data$crmObject === void 0 || (_data$crmObject = _data$crmObject.deal_currency_code) === null || _data$crmObject === void 0 ? void 0 : _data$crmObject.value,
      title: (_data$crmObject$defau = data === null || data === void 0 || (_data$crmObject2 = data.crmObject) === null || _data$crmObject2 === void 0 || (_data$crmObject2 = _data$crmObject2.defaultProperties) === null || _data$crmObject2 === void 0 || (_data$crmObject2 = _data$crmObject2.dealname) === null || _data$crmObject2 === void 0 ? void 0 : _data$crmObject2.value) !== null && _data$crmObject$defau !== void 0 ? _data$crmObject$defau : '',
      lineItems: (_data$crmObject$defau2 = data === null || data === void 0 || (_data$crmObject3 = data.crmObject) === null || _data$crmObject3 === void 0 || (_data$crmObject3 = _data$crmObject3.defaultAssociations) === null || _data$crmObject3 === void 0 || (_data$crmObject3 = _data$crmObject3.toLineItems) === null || _data$crmObject3 === void 0 ? void 0 : _data$crmObject3.edges) !== null && _data$crmObject$defau2 !== void 0 ? _data$crmObject$defau2 : [],
      contactId: data === null || data === void 0 || (_data$crmObject4 = data.crmObject) === null || _data$crmObject4 === void 0 || (_data$crmObject4 = _data$crmObject4.defaultAssociations) === null || _data$crmObject4 === void 0 || (_data$crmObject4 = _data$crmObject4.toContacts) === null || _data$crmObject4 === void 0 || (_data$crmObject4 = _data$crmObject4.edges[0]) === null || _data$crmObject4 === void 0 || (_data$crmObject4 = _data$crmObject4.node) === null || _data$crmObject4 === void 0 ? void 0 : _data$crmObject4.id,
      companyId: data === null || data === void 0 || (_data$crmObject5 = data.crmObject) === null || _data$crmObject5 === void 0 || (_data$crmObject5 = _data$crmObject5.defaultAssociations) === null || _data$crmObject5 === void 0 || (_data$crmObject5 = _data$crmObject5.toCompanies) === null || _data$crmObject5 === void 0 || (_data$crmObject5 = _data$crmObject5.edges[0]) === null || _data$crmObject5 === void 0 || (_data$crmObject5 = _data$crmObject5.node) === null || _data$crmObject5 === void 0 ? void 0 : _data$crmObject5.id
    };
  });
}